import { FC } from 'react';
import { Global } from '@emotion/react';

import { useTenantedApplicationConfig } from '../contexts';

export const GlobalStyles: FC = () => {
  const { styles } = useTenantedApplicationConfig();

  if (!styles?.global) return null;

  return (
    <Global
      styles={`
        ${styles.global}

        @property --shimmer-rotate-angle {
          syntax: '<angle>';
          initial-value: 0deg;
          inherits: false;
        }
      `}
    />
  );
};
